import React from 'react'
import styled from 'styled-components'
import Container from '../container'
import BlackToWhite from '../black_to_white'
import Black from '../black'

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 20px;
  border-radius: 20px;
`

const Image = styled.img`
  aspect-ratio: 4/5;
  object-fit: cover;
  border-radius: 20px;
`

const TwoImages = ({module}) => {

  if(module.background_black_white_hide) {
    return (
      <Black>
       <Container mt0>
          <Flex>
            <div>
              <Image src={module.left_image.asset.publicUrl} />
            </div>

            <div>
              <Image src={module.right_image.asset.publicUrl} />
            </div>

          </Flex>
        </Container>
      </Black>
    )
  } else {
    return (
      <BlackToWhite>
        <Container mt0>
          <Flex>
            <div>
              <Image src={module.left_image.asset.publicUrl} />
            </div>

            <div>
              <Image src={module.right_image.asset.publicUrl} />
            </div>

          </Flex>
        </Container>
      </BlackToWhite>
    )
  }
}

export default TwoImages
